export const calculateUtilization = (totalVolume: number, volumeAdded: number) => {
  if (totalVolume == null || volumeAdded == null) return 0; // ✅ Only check for `null` or `undefined`

  if (totalVolume === 0) return 0; // ✅ Prevent division by zero

  return Math.round((volumeAdded * 100) / totalVolume);
};
